import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='skeleton' className={cn('bg-accent animate-pulse rounded-md', className)} {...props} />
}

export { Skeleton }

export const FullPageSkeleton = () => {
  return (
    <div className='flex flex-1 flex-col pt-5 gap-4 p-4  h-full'>
      <div className='space-y-6'>
        {/* Content grid skeleton */}
        <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
          <div className='space-y-4'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
          <div className='space-y-4'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
          <div className='space-y-4'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
        </div>

        {/* Additional content skeleton */}
        <div className='space-y-4'>
          <Skeleton className='h-6 w-48' />
          <div className='grid gap-4 md:grid-cols-2'>
            <Skeleton className='h-32 w-full rounded-lg' />
            <Skeleton className='h-32 w-full rounded-lg' />
          </div>
        </div>
        <div className='space-y-4'>
          <div className='grid gap-4 md:grid-cols-2'>
            <Skeleton className='h-32 w-full rounded-lg' />
            <Skeleton className='h-32 w-full rounded-lg' />
          </div>
        </div>
      </div>
    </div>
  )
}

export const CardSkeleton = () => {
  return (
    <div className='flex flex-1 flex-col pt-5 gap-4 p-4  h-full'>
      <div className='space-y-6'>
        {/* Content grid skeleton */}
        <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
          <div className='space-y-4'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
          <div className='space-y-4 md:block hidden'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
          <div className='space-y-4 md:block hidden'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
        </div>

        {/* Additional content skeleton */}
        <div className='space-y-4 md:block hidden'>
          <Skeleton className='h-6 w-48' />
          <div className='grid gap-4 md:grid-cols-2'>
            <Skeleton className='h-32 w-full rounded-lg' />
            <Skeleton className='h-32 w-full rounded-lg' />
          </div>
        </div>
      </div>
    </div>
  )
}

export const SmallCardSkeleton = () => {
  return (
    <div className='flex flex-1 flex-col pt-5 gap-4 p-4  h-full'>
      <div className='space-y-6'>
        {/* Content grid skeleton */}
        <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
          <div className='space-y-4 '>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
          <div className='space-y-4 md:block hidden'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
          <div className='space-y-4 md:block hidden'>
            <Skeleton className='h-48 w-full rounded-lg' />
            <div className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-4 w-1/2' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
